import { postsRoutes } from './posts';
import { aboutUsRoutes } from './about-us';
import { specialtyRoutes } from './specialty';
import { clientRoutes } from './client';
import { usersRoutes } from './users';
import { homeScreenRoutes } from './home-screen';
import { labsRoutes } from './labs';
import { appointmentRoutes } from './appointment';
import { financialsRoutes } from './financials';
import { consultsRoutes } from './consults';
import { discountsRoutes } from './discounts';
import { contactsRoutes } from './contacts';
import { homeCareRoutes } from './home-care';
import { prescriptionRoutes } from './prescription';
import { pharmaciesRoutes } from './pharmacies';
import { notificationsRoutes } from './notifications';
import { parsiMapRoutes } from './parsi-map';
import { servicesRoutes } from './services';
import { emtaRoutes } from './emta';
import { locationsRoutes } from './locations';
import { productRoutes } from './products';
import { basketRoutes } from './basket';
import { settingRoutes } from './settings';
import { policyRoutes } from './policy';
import { surveyRoutes } from './survey';
import { calendarRoutes } from './calendar';
import { faqRoutes } from './faq';

const routes = {
  ...postsRoutes,
  ...aboutUsRoutes,
  ...specialtyRoutes,
  ...clientRoutes,
  ...usersRoutes,
  ...homeScreenRoutes,
  ...labsRoutes,
  ...appointmentRoutes,
  ...financialsRoutes,
  ...consultsRoutes,
  ...discountsRoutes,
  ...contactsRoutes,
  ...homeCareRoutes,
  ...prescriptionRoutes,
  ...pharmaciesRoutes,
  ...notificationsRoutes,
  ...parsiMapRoutes,
  ...servicesRoutes,
  ...emtaRoutes,
  ...locationsRoutes,
  ...productRoutes,
  ...basketRoutes,
  ...settingRoutes,
  ...policyRoutes,
  ...surveyRoutes,
  ...calendarRoutes,
  ...faqRoutes,
};

export default routes;
